module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "site-navbar navbar navbar-default navbar-inverse navbar-fixed-top navbar-mega",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topBarInfoEnabled),
      expression: "topBarInfoEnabled"
    }],
    staticClass: "text-center topbar-info",
    style: (_vm.topBarInfoStyle),
    domProps: {
      "innerHTML": _vm._s(_vm.topBarInfoText)
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topBarInfoEnabled),
      expression: "topBarInfoEnabled"
    }],
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideTopBarInfo()
      }
    }
  }, [_c('span', {
    staticClass: "top-bar-close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.displayBanner),
      expression: "displayBanner"
    }],
    staticClass: "text-center topbar-info",
    style: (_vm.topBarInfoStyle),
    domProps: {
      "innerHTML": _vm._s(_vm.topBarInfoTextAirbnbxml)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler collapsed",
    attrs: {
      "type": "button",
      "data-target": "#site-navbar-search",
      "data-toggle": "collapse"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.globalSearch()
      }
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand navbar-brand-center site-gridmenu-toggle",
    attrs: {
      "to": {
        name: 'calendar.type',
        params: {
          type: _vm.calendarPage
        }
      },
      "data-toggle": "gridmenu"
    }
  }, [_c('img', {
    staticClass: "navbar-brand-logo",
    attrs: {
      "src": "static/material/iconbar/assets/images/SUPERHOTE-LOGO-nkrerildmc1s1dkokfg138v5uncyjipddjpgdd0ue0.png",
      "title": "Super Booking",
      "alt": "Super Booking"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-container container-fluid"
  }, [_c('div', {
    staticClass: "collapse navbar-collapse navbar-collapse-toolbar",
    attrs: {
      "id": "site-navbar-collapse"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-toolbar"
  }, [_vm._m(3), _vm._v(" "), _c('li', {
    staticClass: "nav-item hidden-float"
  }, [_c('a', {
    staticClass: "nav-link icon",
    attrs: {
      "data-toggle": "collapse",
      "href": "#",
      "data-target": "#site-navbar-search",
      "role": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.globalSearch()
      }
    }
  }, [_c('span', {
    staticClass: "global-search"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.search')))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-toolbar navbar-right navbar-toolbar-right"
  }, [_c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModalButton),
      expression: "showModalButton"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "id": "modalBtn",
      "data-toggle": "modal",
      "type": "button",
      "data-target": "#downloadApp"
    }
  }, [_vm._v("BUTTON")])]), _vm._v(" "), (_vm.supportAccess || parseInt(_vm.user.is_team_member) === 0) ? _c('li', {
    staticClass: "nav-item d-flex align-items-center icon-question-container",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModal('#support-modal')
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-create-send magic-link"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('modal.help_button')) + "\n            ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown lang"
  }, [_c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [(_vm.account.lang != 'en') ? _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('en')
      }
    }
  }, [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.account.lang != 'fr') ? _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('fr')
      }
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (_vm.account.lang != 'pt') ? _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('pt')
      }
    }
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.account.lang != 'es') ? _c('li', {
    attrs: {
      "role": "presentation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLang('es')
      }
    }
  }, [_vm._m(7)]) : _vm._e()]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-toggle nav-link nav-link2 d-flex justify-content-center align-items-center",
    attrs: {
      "data-toggle": "dropdown",
      "href": "javascript:void(0)",
      "data-animation": "scale-up",
      "aria-expanded": "false",
      "role": "button"
    }
  }, [_c('span', {
    class: _vm.account.lang == 'en' ? 'flag-icon flag-icon-us' : _vm.account.lang == 'fr' ? 'flag-icon flag-icon-fr' : _vm.account.lang == 'pt' ? 'flag-icon flag-icon-pt' : _vm.account.lang == 'es' ? 'flag-icon flag-icon-es' : 'flag-icon flag-icon-us'
  })])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item dropdown"
  }, [_c('a', {
    staticClass: "nav-link navbar-avatar nav-link2",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#",
      "aria-expanded": "false",
      "data-animation": "scale-up",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.account && _vm.account.avatar ? (_vm.account.avatarPath ? _vm.account.avatarPath : _vm.account.avatar) : 'static/material/global/portraits/avatar.png',
      "alt": "..."
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.account.first_name))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'account.settings'
      },
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "icon md-settings",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('menu.settings')) + " ")]), _vm._v(" "), ((_vm.account && _vm.account.role ? _vm.account.role.id == 1 : false)) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'admin.index'
      },
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "icon md-settings",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('menu.admin_screen')) + " ")]) : _vm._e(), _vm._v(" "), ((_vm.account && _vm.account.role ? _vm.account.role.id == 1 : false)) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'payment.messages'
      },
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "icon md-settings",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('menu.payment_messages_screen')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.user.is_team_member == 0) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'account.team'
      },
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "fa fa-users icon",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('account.settings.team_section.tab_title')))]) : _vm._e()], 1)]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-logout nav-link2",
    attrs: {
      "href": "logout",
      "role": "menuitem"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/exit.svg",
      "alt": "logout"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-search-overlap collapse",
    attrs: {
      "id": "site-navbar-search",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listView && _vm.listView.length == 0 && _vm.filterByName && _vm.filterByName.length > 0),
      expression: "listView && listView.length == 0 && filterByName && filterByName.length > 0"
    }],
    staticClass: "autocomplete-box"
  }, [_c('h3', {
    staticClass: "text-color-orange search-result"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.search_result')))]), _vm._v(" "), _c('span', {
    staticClass: "no-matches-found"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.no_matches_found')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "site-menubar",
    style: ({
      top: 0,
      marginTop: _vm.topHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "site-menubar-body"
  }, [_c('div', [_c('div', [_c('ul', {
    staticClass: "site-menu",
    attrs: {
      "data-plugin": "menu"
    }
  }, [(_vm.account.is_team_member == 0 || (_vm.account.is_team_member == 1 && _vm.checkUserAccessToTab('calendar'))) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'calendar')
    },
    attrs: {
      "id": "calendar-icon"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'calendar.type',
        params: {
          type: _vm.calendarPage
        }
      }
    }
  }, [_c('i', {
    staticClass: "icomoon icon-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.calendar')))])])], 1) : _vm._e(), _vm._v(" "), ((_vm.account.is_team_member == 1 && _vm.checkUserAccessToTab('bookings')) || _vm.account.is_team_member == 0) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'bookings')
    },
    attrs: {
      "id": "bookings-icon"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bookings.index'
      }
    }
  }, [_c('i', {
    staticClass: "icomoon icon-bookings",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.bookings')))])])], 1) : _vm._e(), _vm._v(" "), ((_vm.account.is_team_member == 1 && _vm.checkUserAccessToTab('messages')) || _vm.account.is_team_member == 0) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'messages')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'messages.index'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.messages')))])])], 1) : _vm._e(), _vm._v(" "), ((_vm.account.is_team_member == 1 && _vm.checkUserAccessToTab('analytics')) || _vm.account.is_team_member == 0) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'analytics')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'analytics.index'
      }
    }
  }, [_c('i', {
    staticClass: "icomoon icon-guests",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.analytics')) + " ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.account.is_team_member == 1 && _vm.checkUserAccessToTab('payments')) || _vm.account.is_team_member == 0) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'payments')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'payments.index'
      }
    }
  }, [_c('i', {
    staticClass: "icomoon icon-payments",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.payments')))])])], 1) : _vm._e(), _vm._v(" "), ((_vm.account.is_team_member == 1 && _vm.checkUserAccessToTab('rentals')) || _vm.account.is_team_member == 0) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'rentals')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'rentals.index'
      }
    }
  }, [_c('i', {
    staticClass: "icomoon icon-rentals",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.rentals')))])])], 1) : _vm._e(), _vm._v(" "), ((_vm.account.is_team_member == 1 && _vm.checkUserAccessToTab('autoactions')) || _vm.account.is_team_member == 0) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'automation')
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'automation.index'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cogs",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('automation.index.title')))])])], 1) : _vm._e(), _vm._v(" "), (false) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'users')
    }
  }, [(!_vm.account.parent_id) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'users.index'
      },
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "icon md-accounts",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.users')))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (false) ? _c('li', {
    staticClass: "site-menu-item",
    class: {
      active: (_vm.activeMenu == 'market')
    }
  }, [_c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": {
        name: 'market.index'
      },
      "role": "menuitem"
    }
  }, [_c('i', {
    staticClass: "icon md-accounts",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "site-menu-title"
  }, [_vm._v(_vm._s(_vm.$t('menu.market')))])])], 1) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "global-search"
    }
  }, [_c('v-loading', {
    staticStyle: {
      "position": "relative",
      "z-index": "7777"
    },
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay",
    attrs: {
      "data-pages": "search"
    }
  }, [_c('div', {
    staticClass: "overlay-content has-results m-t-20"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('img', {
    staticClass: "overlay-brand",
    attrs: {
      "src": "static/material/iconbar/assets/images/SUPERHOTE-LOGO-nkrerildmc1s1dkokfg138v5uncyjipddjpgdd0ue0.png",
      "alt": "logo",
      "data-src": "static/material/iconbar/assets/images/SUPERHOTE-LOGO-nkrerildmc1s1dkokfg138v5uncyjipddjpgdd0ue0.png",
      "data-src-retina": "assets/img/logo_2x.png"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "close-icon-light overlay-close text-black fs-50",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeGlobalSearch()
      }
    }
  }, [_c('i', {
    staticClass: "icon md-close"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterByName),
      expression: "filterByName"
    }],
    staticClass: "no-border overlay-search bg-transparent",
    attrs: {
      "id": "overlay-search",
      "placeholder": _vm.$t('booking.index.search_placeholder'),
      "autocomplete": "off",
      "spellcheck": "false",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.filterByName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filterByName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "search-results"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listView && _vm.listView.length > 0 && _vm.filterByName && _vm.filterByName.length > 0 && !_vm.isLoading),
      expression: "listView && listView.length > 0 && filterByName && filterByName.length > 0 && !isLoading"
    }],
    staticClass: "autocomplete-box"
  }, [_c('h3', {
    staticClass: "text-color-orange search-result"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.search_result')))]), _vm._v(" "), _c('table', {
    staticClass: "row-link table table-responsive",
    attrs: {
      "id": "bookings-table"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "booking-id"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.id')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-rental"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.rental')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.guest')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkin')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('booking.index.checkout')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-nights"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.nights')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-people"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.people')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-channel"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.channel')))]), _vm._v(" "), _c('th', {
    staticClass: "booking-action"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.status_title')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listView), function(booking) {
    return _c('tr', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toBookingItem(booking.id)
        }
      }
    }, [_c('td', [_c('div', [_vm._v(_vm._s(booking.id))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(booking.rental ? booking.rental.name : "N/A"))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(booking.guest.first_name) + " " + _vm._s(booking.guest.last_name))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm._f("changeDateFormat")(booking.checking, 'dd MMMM DD. YYYY')))])]), _vm._v(" "), _c('td', [_c('div', [_vm._v(_vm._s(_vm._f("changeDateFormat")(booking.checkout, 'dd MMMM DD. YYYY')))])]), _vm._v(" "), _c('td', [_c('div', [_c('i', {
      staticClass: "icon-rental-moon"
    }), _vm._v(" " + _vm._s(_vm._f("calculateNight")(booking.checking, booking.checkout)) + "\n                      ")])]), _vm._v(" "), _c('td', [_c('div', [_c('i', {
      staticClass: "icon-rental-user"
    }), _vm._v(" " + _vm._s(booking.nbr_adults))])]), _vm._v(" "), _c('td', [_c('div', {
      class: (booking.channel && booking.channel.logo == 'hotels2.png') ? 'hotels2' : ((booking.channel && booking.channel.logo) ? '' : 'd-flex justify-content-center align-items-center')
    }, [_c('img', {
      class: (booking.channel && booking.channel.logo) ? '' : 'default-rent',
      attrs: {
        "src": booking.channel && booking.channel.logo ? '/static/assets/images/' + booking.channel.logo : '/static/assets/images/SuperHote_icons/rent.png'
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "booking-action"
    }, [_c('div', [_c('span', {
      staticClass: "status-booking",
      class: _vm.getBookingClassName(booking.status, booking.statusCode, booking.payment_is_done)
    }, [_vm._v(_vm._s(_vm.getBookingStatusName(booking.status, booking.statusCode, booking.payment_is_done)))])])])])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listView && _vm.listView.length === 0 && !_vm.isGettingBookings && _vm.filterByName && _vm.filterByName.length > 0 && !_vm.isLoading),
      expression: "listView && listView.length === 0 && !isGettingBookings && filterByName && filterByName.length > 0 && !isLoading"
    }],
    staticClass: "autocomplete-box"
  }, [_c('h3', {
    staticClass: "text-color-orange search-result"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.search_result')))]), _vm._v(" "), _c('span', {
    staticClass: "no-matches-found"
  }, [_vm._v(_vm._s(_vm.$t('booking.index.no_matches_found')))])])])])])])], 1), _vm._v(" "), _c('div', {
    style: ({
      marginTop: _vm.topHeight + 'px'
    })
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-lg modal-not-confirmed",
    attrs: {
      "id": "wizard-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body  modal-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-align-center form-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/verify-email--red.png",
      "width": "150",
      "alt": "mail"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-red"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('home.verify_modal_text_1')))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('home.verify_modal_text_3'))), _c('br'), _vm._v(_vm._s(_vm.$t('home.verify_modal_text_4')))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.account.email))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('home.verify_modal_text_5'))), _c('br'), _c('a', {
    staticClass: "text-red",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resend_email()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home.verify_modal_text_6')))]), _vm._v(" or "), _c('a', {
    staticClass: "text-orange",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t('home.contact_support')))])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "downloadApp",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-11 col-sm-11 col-md-11 col-10",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('h2', {
    staticClass: "mobile-app-links-header text-center",
    staticStyle: {
      "font-size": "17px"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.user_services_section.download_mobile_app")))])]), _vm._v(" "), _vm._m(8)])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade tax-modal",
    attrs: {
      "id": "support-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center modal-medium"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$t('modal.contact_us')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modal.contact_us_desc')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#support-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "help-badges row justify-content-center"
  }, [_c('div', {
    staticClass: "help-icon col-3"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://help.superhote.com"
    }
  }, [_c('i', {
    staticClass: "far fa-book"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modal.docs')))])])]), _vm._v(" "), _c('div', {
    staticClass: "help-icon col-3"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://superhote.com/demarrage"
    }
  }, [_c('i', {
    staticClass: "far fa-calendar-check-o"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modal.onboarding')))])])]), _vm._v(" "), _c('div', {
    staticClass: "help-icon col-3"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://help.superhote.com/support/tickets/new"
    }
  }, [_c('i', {
    staticClass: "far fa-comments"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modal.live_chat')))])])]), _vm._v(" "), _c('div', {
    staticClass: "help-icon col-3"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://superhote.com/book"
    }
  }, [_c('i', {
    staticClass: "far fa-calendar"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modal.book_consultation')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "help-badges row justify-content-center"
  }, [_c('div', {
    staticClass: "help-icon col-3"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://superhote.com/idee"
    }
  }, [_c('i', {
    staticClass: "fa fa-lightbulb-o"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modal.ideas')))])])]), _vm._v(" "), _c('div', {
    staticClass: "help-icon col-3"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://superhote.com/group"
    }
  }, [_c('i', {
    staticClass: "far fa fa-users"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modal.community')))])])]), _vm._v(" "), (_vm.account.affiliate_id) ? _c('div', {
    staticClass: "help-icon col-3"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": ("https://superhote.com/affiliation?id=" + (_vm.account.affiliate_id))
    }
  }, [_c('img', {
    attrs: {
      "width": "52",
      "src": require("../../../../static/assets/images/icons/coins_bag_.svg"),
      "alt": "Money bag"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('modal.earn_money')))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-lg sync-in-process-modal",
    attrs: {
      "id": "wizard-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body  modal-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-align-center form-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/verify-email--red.png",
      "width": "150",
      "alt": "mail"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-red"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('home.verify_modal_text_1')))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('home.sync_in_process_text_1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('home.sync_in_process_text_2')))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.account.email))])]), _vm._v(" "), (_vm.showUnSyncText()) ? _c('div', {
    staticClass: "text-center mt-50"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unLockUser($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home.unsync_text')))])]) : _vm._e()]), _vm._v(" "), _c('br'), _c('br')])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-lg onBoarding-modal",
    attrs: {
      "id": "wizard-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body  modal-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 form-content",
    staticStyle: {
      "display": "table"
    }
  }, [(_vm.user.onboarding_step == 99) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "panel default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("account.settings.user_platforms_section.airlock_validation_title")))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 auto",
      "text-align": "center"
    }
  }, [_c('v-loading', {
    attrs: {
      "isLoading": true,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-top": "24px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('account.settings.user_platforms_section.airlock_validation'))
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step == 1) ? _c('div', [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.next(_vm.user.onboarding_step)
      }
    }
  }, [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v("\n                        " + _vm._s(_vm.$t("onboarding.user_info")) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.first_name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.first_name),
      expression: "user.first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "first_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "first_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-sm-6 form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.last_name")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.last_name),
      expression: "user.last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "last_name",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.email")))]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "disabled": "disabled",
      "required": ""
    },
    domProps: {
      "value": _vm.user.email
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.phone")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "phone",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-lang"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.lang")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.lang),
      expression: "user.lang"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "settings-lang"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "lang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.code.toLowerCase()
      }
    }, [_vm._v(_vm._s(country.name) + "\n                        ")])
  }))])]), _vm._v(" "), (_vm.user.onboarding_step > 1 && _vm.user.onboarding_step != 5) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-left",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previous(_vm.user.onboarding_step)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.previous")))]) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step < 4) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step == 2) ? _c('div', [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.next(_vm.user.onboarding_step)
      }
    }
  }, [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_vm._m(10), _vm._v("\n                        " + _vm._s(_vm.$t("onboarding.billing_info")) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "address"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.address")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.address),
      expression: "user.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "address",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "city"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.city")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.city),
      expression: "user.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "city",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "zip_code"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.zip_code")))]), _vm._v(" "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.zip_code),
      expression: "user.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "zip_code",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "zip_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "settings-country"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.country")))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.country_id),
      expression: "user.country_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "settings-country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v(_vm._s(country.name))])
  }))])])])]), _vm._v(" "), (_vm.user.onboarding_step > 1 && _vm.user.onboarding_step != 4) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-left",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previous(_vm.user.onboarding_step)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.previous")))]) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step < 3) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step == 3) ? _c('div', {
    staticStyle: {
      "height": "auto"
    }
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.billingInfo.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.billingInfo.loading),
      expression: "!billingInfo.loading"
    }]
  }, [_c('form', {
    attrs: {
      "autocomplete": "off",
      "id": "billingInfoForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.next(3)
      }
    }
  }, [_c('div', {
    staticClass: "step-body",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_vm._m(11), _vm._v("\n                          " + _vm._s(_vm.$t('onboarding.configure_stripe')) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "card-number-billing"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("account.settings.credit_card.card_number")) + "\n                            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingInfo.cardNumber),
      expression: "billingInfo.cardNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-stripe": "number",
      "pattern": "4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\\d{3})\\d{11}",
      "id": "card-number-billing",
      "name": "card_number",
      "placeholder": "0000 0000 0000 0000",
      "required": "required"
    },
    domProps: {
      "value": (_vm.billingInfo.cardNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingInfo, "cardNumber", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "exp_month",
      "size": "2",
      "data-stripe": "exp_month"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "exp_year",
      "size": "2",
      "data-stripe": "exp_year"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "card-expiration-billing"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.credit_card.card_expiration")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingInfo.cardExpiration),
      expression: "billingInfo.cardExpiration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "7",
      "pattern": "^\\d{1,2}\\s?\\/\\s?\\d{1,4}$",
      "id": "card-expiration-billing",
      "placeholder": "MM/YY",
      "required": "required"
    },
    domProps: {
      "value": (_vm.billingInfo.cardExpiration)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingInfo, "cardExpiration", $event.target.value)
      }, _vm.cardExpChange]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "card-cvc-billing"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("account.settings.credit_card.card_cvc")) + "\n                            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingInfo.cardCvc),
      expression: "billingInfo.cardCvc"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "^\\d{3,4}$",
      "minlength": "3",
      "maxlength": "3",
      "size": "5",
      "data-stripe": "cvc",
      "id": "card-cvc-billing",
      "name": "card_cvc",
      "placeholder": "***",
      "required": "required"
    },
    domProps: {
      "value": (_vm.billingInfo.cardCvc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingInfo, "cardCvc", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "connect-card-desc"
  }, [_c('ul', {
    staticClass: "subscribe-reason-items"
  }, [_c('li', {
    staticClass: "subscribe-reason-item"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_item_1")))])]), _vm._v(" "), _c('li', {
    staticClass: "subscribe-reason-item font-weight-600"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_item_2")) + " " + _vm._s(_vm.subscriptionStartDate))])]), _vm._v(" "), _c('li', {
    staticClass: "subscribe-reason-item"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_item_3")))])]), _vm._v(" "), _c('li', {
    staticClass: "subscribe-reason-item"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_item_4")))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "#f5e1e5",
      "padding": "10px",
      "border-radius": "5px",
      "margin": "10px 0"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.annual_title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.annual_description")))])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("button.next")) + "\n                    ")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step == 0) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_vm._m(13), _vm._v("\n                      " + _vm._s(_vm.$t('account.settings.user_platforms_section.verify_and_connect')) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.verification_method_choice')))]), _vm._v(" "), _c('div', {
    staticClass: "m-10 radio-custom radio-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verificationFrictionType),
      expression: "verificationFrictionType"
    }],
    attrs: {
      "type": "radio",
      "id": "phone_verification_via_text",
      "value": "phone_verification_via_text"
    },
    domProps: {
      "checked": _vm._q(_vm.verificationFrictionType, "phone_verification_via_text")
    },
    on: {
      "change": function($event) {
        _vm.verificationFrictionType = "phone_verification_via_text"
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "phone_verification_via_text"
    }
  }, [_vm._v("Phone Verification via\n                            Text")])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getFrictionVew()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))])]) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step == 4) ? _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.airbnbAccount.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.airbnbAccount.loading),
      expression: "!airbnbAccount.loading"
    }]
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.next(_vm.user.onboarding_step)
      }
    }
  }, [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_vm._m(14), _vm._v("\n                          " + _vm._s(_vm.$t('account.settings.user_platforms_section.fill_account_credentials')) + "\n                        ")])]), _vm._v(" "), (_vm.airbnbAccount.error) ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [(_vm.airbnbAccount.id && _vm.airbnbAccount.user_id) ? _c('div', [_vm._v("\n                          " + _vm._s(_vm.$t("account.settings.verification1")) + "\n                          "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.airbnbAccount.id ? 'https://www.airbnb.com/airlock?al_id=' + _vm.airbnbAccount.id : ''
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.airbnbAccount.id ? _vm.$t("account.settings.clickhere") : ''))]), _vm._v("\n                          " + _vm._s(_vm.$t("account.settings.verification2")) + "\n                        ")]) : _c('div', [_vm._v("\n                          " + _vm._s(_vm.airbnbAccount.error) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.airbnbAccount.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.airbnbAccount.success) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "airbnb-username"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.airbnb_username")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.airbnbAccount.airbnbUsername),
      expression: "airbnbAccount.airbnbUsername"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "airbnb-username",
      "required": ""
    },
    domProps: {
      "value": (_vm.airbnbAccount.airbnbUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.airbnbAccount, "airbnbUsername", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "airbnb-password"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.airbnb_password")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.airbnbAccount.airbnbPassword),
      expression: "airbnbAccount.airbnbPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "airbnb-password",
      "required": ""
    },
    domProps: {
      "value": (_vm.airbnbAccount.airbnbPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.airbnbAccount, "airbnbPassword", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "connect-airbnb-desc"
  }, [_c('ul', {
    staticClass: "airbnb-reason-items"
  }, [_c('li', {
    staticClass: "airbnb-reason-item"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("onboarding.connect_airbnb.reason_line_1")) + "\n                              ")]), _vm._v(" "), _c('li', {
    staticClass: "airbnb-reason-item"
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("onboarding.connect_airbnb.reason_line_2")) + "\n                              ")]), _vm._v(" "), _c('li', {
    staticClass: "airbnb-reason-item"
  }, [_c('span', [_vm._v("\n                                  " + _vm._s(_vm.$t("onboarding.connect_airbnb.reason_line_3")) + "\n                                ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.airbnb.com/forgot_password",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("onboarding.connect_airbnb.click_here")))])])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("button.next")) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right mr-10",
    attrs: {
      "type": "submit",
      "disabled": _vm.airbnbAccount.loading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createUserSubscriptions()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.skip_for_now")))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step == 5) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_vm._m(15), _vm._v("\n                      " + _vm._s(_vm.$t('account.settings.user_platforms_section.confirm_captcha')) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.redirect_captcha_message')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary ml-auto mr-auto mt-60 waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.verifyAccount(_vm.airbnbAccount.airLockId)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('account.settings.user_platforms_section.confirm_account_button')))])])]), _vm._v(" "), ((_vm.user.onboarding_step == 4)) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next(_vm.user.onboarding_step)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))]) : _vm._e()]) : _vm._e(), _vm._v(" "), ((_vm.user.onboarding_step == 6)) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_vm._m(16), _vm._v("\n                      " + _vm._s(_vm.$t('account.settings.user_platforms_section.verify_and_connect')) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel-default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.settings.user_platforms_section.verification_method_choice')) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.verificationFrictionData), function(data) {
    return _c('div', {
      staticClass: "m-10 radio-custom radio-primary"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.verificationFrictionType),
        expression: "verificationFrictionType"
      }],
      class: data.name,
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "account_confirmation"
      },
      domProps: {
        "value": data.name,
        "checked": _vm._q(_vm.verificationFrictionType, data.name)
      },
      on: {
        "change": function($event) {
          _vm.verificationFrictionType = data.name
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "control-label",
      attrs: {
        "for": data.id
      }
    }, [_vm._v(_vm._s(data.text))])])
  })], 2)])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.verifyAirbnbAccountViaPhoneOrEmail()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))])]) : _vm._e(), _vm._v(" "), ((_vm.user.onboarding_step == 7)) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "panel-default"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('p', {
    staticClass: "panel-title verification-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t('account.settings.user_platforms_section.confirm_airbnb_sent_code')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material col-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "airbnb-code"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("input.airbnb_code")) + "\n                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.airbnbVerificationCode),
      expression: "airbnbVerificationCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "airbnb-code",
      "required": ""
    },
    domProps: {
      "value": (_vm.airbnbVerificationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.airbnbVerificationCode = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.checkAirBnbVerificationCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.next")))])]) : _vm._e(), _vm._v(" "), (_vm.user.onboarding_step == 10) ? _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.airbnbAccount.loading
    }
  }), _vm._v(" "), (!_vm.airbnbAccount.loading) ? _c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _vm._v(" " + _vm._s(_vm.$t("onboarding.setup_successful")) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "setup-successful"
  }, [_c('div', {
    staticClass: "text-color-orange"
  }, [_vm._v(_vm._s(_vm.$t("onboarding.process_successful")))]), _vm._v(" "), _c('div', {
    staticClass: "quick-tour"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-center waves-effect waves-classic btn-save text-uppercase",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.get_started()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.get_started")))])])])]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 wizart-content"
  }, [_c('div', {
    staticClass: "wizart-line"
  }), _vm._v(" "), _c('ul', {
    staticClass: "wizart-list"
  }, [_c('li', {
    staticClass: "wizart-point",
    class: _vm.user.onboarding_step == 1 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.onboarding_step == 1),
      expression: "user.onboarding_step == 1"
    }]
  }, [_vm._v(" 1 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.onboarding_step > 1),
      expression: "user.onboarding_step > 1"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v("\n                  " + _vm._s(_vm.$t("onboarding.user_info")) + "\n                ")]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.user.onboarding_step == 2 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.onboarding_step == 2 || _vm.user.onboarding_step < 2),
      expression: "user.onboarding_step == 2 || user.onboarding_step < 2"
    }]
  }, [_vm._v(" 2 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.onboarding_step > 2),
      expression: "user.onboarding_step > 2"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v("\n                  " + _vm._s(_vm.$t("onboarding.billing_info")) + "\n                ")]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.user.onboarding_step == 3 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.onboarding_step < 4 || _vm.user.onboarding_step == 3),
      expression: "user.onboarding_step < 4 || user.onboarding_step == 3"
    }]
  }, [_vm._v(" 3 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.onboarding_step > 3),
      expression: "user.onboarding_step > 3"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v("\n                  " + _vm._s(_vm.$t("onboarding.configure_stripe")) + "\n                ")]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.user.onboarding_step == 10 ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.onboarding_step < 10),
      expression: "user.onboarding_step < 10"
    }]
  }, [_vm._v(" 4 ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user.onboarding_step == 10),
      expression: "user.onboarding_step == 10"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v("\n                  " + _vm._s(_vm.$t("start_using_supermanager")) + "\n                ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-lg prelaunch-modal",
    attrs: {
      "id": "wizard-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body modal-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 form-content"
  }, [(_vm.connectNewCard) ? _c('div', [_c('v-loading', {
    attrs: {
      "isLoading": _vm.billingInfo.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.billingInfo.loading),
      expression: "!billingInfo.loading"
    }]
  }, [_c('form', {
    attrs: {
      "autocomplete": "off",
      "id": "billingForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.connectStripeCard($event)
      }
    }
  }, [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title-icon"
  }, [_vm._m(17), _vm._v("\n                          " + _vm._s(_vm.$t('onboarding.billing_configuration')) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "card-number-billing"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("account.settings.credit_card.card_number")) + "\n                            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "data-stripe": "number",
      "pattern": "4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|6(?:011|5[0-9]{2})[0-9]{12}|(?:2131|1800|35\\d{3})\\d{11}",
      "id": "card-number-billing",
      "name": "card_number",
      "placeholder": "0000 0000 0000 0000",
      "required": "required"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "card-cvc-billing"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("account.settings.credit_card.card_cvc")) + "\n                            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "pattern": "^\\d{3,4}$",
      "minlength": "3",
      "maxlength": "3",
      "size": "5",
      "data-stripe": "cvc",
      "id": "card-cvc-billing",
      "name": "card_cvc",
      "placeholder": "***",
      "required": "required"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "id": "exp_month",
      "size": "2",
      "data-stripe": "exp_month"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "exp_year",
      "size": "2",
      "data-stripe": "exp_year"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "card-expiration-billing"
    }
  }, [_vm._v(_vm._s(_vm.$t("account.settings.credit_card.card_expiration")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billingInfo.cardExpiration),
      expression: "billingInfo.cardExpiration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "7",
      "pattern": "^\\d{1,2}\\s?\\/\\s?\\d{1,4}$",
      "id": "card-expiration-billing",
      "placeholder": "MM/YY",
      "required": "required"
    },
    domProps: {
      "value": (_vm.billingInfo.cardExpiration)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.billingInfo, "cardExpiration", $event.target.value)
      }, _vm.cardExpChange]
    }
  })])])]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "connect-card-desc"
  }, [_c('h4', {
    staticClass: "subscribe-reason-title"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_title")) + "\n                            ")]), _vm._v(" "), _c('ul', {
    staticClass: "subscribe-reason-items"
  }, [_c('li', {
    staticClass: "subscribe-reason-item"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_item_1")))])]), _vm._v(" "), _c('li', {
    staticClass: "subscribe-reason-item"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_item_2")) + " " + _vm._s(_vm.subscriptionStartDate))])]), _vm._v(" "), _c('li', {
    staticClass: "subscribe-reason-item"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_item_3")))])]), _vm._v(" "), _c('li', {
    staticClass: "subscribe-reason-item"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _c('span', [_vm._v(_vm._s(_vm.$t("onboarding.connect_card.subscribe_reason_item_4")))])])])])])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save pull-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("button.next")) + "\n                    ")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.subscriptionSuccess) ? _c('div', [_c('div', {
    staticClass: "step-body"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "icon md-check"
  }), _vm._v(" " + _vm._s(_vm.$t("onboarding.config_success")) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "setup-successful"
  }, [_c('div', {
    staticClass: "text-color-orange"
  }, [_vm._v(_vm._s(_vm.$t("onboarding.continue_use_app")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-center waves-effect waves-classic btn-save text-uppercase m-t-25",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.continueUseApp()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("onboarding.continue_use_superhote")))])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 wizart-content"
  }, [_c('div', {
    staticClass: "wizart-line"
  }), _vm._v(" "), _c('ul', {
    staticClass: "wizart-list"
  }, [_c('li', {
    staticClass: "wizart-point",
    class: _vm.connectNewCard ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.subscriptionSuccess),
      expression: "!subscriptionSuccess"
    }]
  }, [_vm._v(" 1\n                  ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subscriptionSuccess),
      expression: "subscriptionSuccess"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v(" " + _vm._s(_vm.$t("onboarding.billing_configuration")) + " ")]), _vm._v(" "), _c('li', {
    staticClass: "wizart-point",
    class: _vm.subscriptionSuccess ? 'active' : ''
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.subscriptionSuccess),
      expression: "!subscriptionSuccess"
    }]
  }, [_vm._v(" 2 ")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subscriptionSuccess),
      expression: "subscriptionSuccess"
    }]
  }, [_c('i', {
    staticClass: "icon md-check"
  })]), _vm._v(" " + _vm._s(_vm.$t("continue_use_superhote")) + " ")])])])])])])])]), _vm._v(" "), _c('educational-modal', {
    attrs: {
      "show": false
    }
  }), _vm._v(" "), _c('v-billingModal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler hamburger hamburger-close navbar-toggler-left hided",
    attrs: {
      "type": "button",
      "data-toggle": "menubar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "hamburger-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler collapsed",
    attrs: {
      "type": "button",
      "data-target": "#site-navbar-collapse",
      "data-toggle": "collapse"
    }
  }, [_c('i', {
    staticClass: "icon md-more",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-toggler nav-link icon wb-search",
    attrs: {
      "id": "wb-search",
      "data-toggle": "collapse",
      "href": "#",
      "data-target": "#site-navbar-search",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Search")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item hidden-float",
    attrs: {
      "id": "toggleMenubar"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "menubar",
      "href": "#",
      "role": "button"
    }
  }, [_c('i', {
    staticClass: "icon hamburger hamburger-arrow-left unfolded hided"
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle menubar")]), _vm._v(" "), _c('span', {
    staticClass: "hamburger-bar"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "role": "menuitem"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-us"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "menuitem"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-fr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "menuitem"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-pt"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "menuitem"
    }
  }, [_c('span', {
    staticClass: "flag-icon flag-icon-es"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-1 col-sm-1 col-ms-1 col-2",
    staticStyle: {
      "margin-left": "-20px"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://play.google.com/store/apps/details?id=com.supermanager.io"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logos/googleplay.png",
      "alt": "playMarket"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://itunes.apple.com/us/app/supermanager/id1259222447?mt=8"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logos/appstore.png",
      "alt": "appStore"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon booking-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/coin-euro.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/coin-euro.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "card-container"
  }, [_c('img', {
    staticClass: "not-applicable-carts",
    attrs: {
      "src": "/static/assets/images/permalink/carts.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/SuperHote_icons/cogs.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/wrench.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/cogs.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/cogs.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/coin-euro.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "card-container"
  }, [_c('img', {
    staticClass: "not-applicable-carts",
    attrs: {
      "src": "/static/assets/images/permalink/carts.png"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cc932f9"}!./src/app/layouts/default/default.html
// module id = 1371
// module chunks = 0